import { createContext } from "react";

const CityContext = createContext();

export default CityContext;
